/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ViewComponentKey {
  static readonly BASE = 'kit-view/component/base';
  static readonly TEXT = 'kit-view/component/text';
  static readonly LABEL = 'kit-view/component/label';
  static readonly IMAGE = 'kit-view/component/image';
  static readonly SVG_SYMBOL = 'kit-view/component/svg-symbol';
  static readonly SVG_CODE = 'kit-view/component/svg-code';
  static readonly ACTION = 'kit-view/component/action';
  static readonly BUTTON = 'kit-view/component/button';
  static readonly LINK = 'kit-view/component/link';
  static readonly DROPDOWN = 'kit-view/component/dropdown';
  static readonly CONTENT = 'kit-view/component/content';
  static readonly CONTAINER = 'kit-view/component/container';
  static readonly LIST = 'kit-view/component/list';
  static readonly TABLE = 'kit-view/component/table';
  static readonly TABLE_ROW = 'kit-view/component/table-row';
  static readonly TABLE_COLUMN = 'kit-view/component/table-column';
  static readonly TABLE_CELL = 'kit-view/component/table-cell';
  static readonly VALUE = 'kit-view/component/value';
  static readonly TEXT_INPUT = 'kit-view/component/text-input';
  static readonly TEXT_AREA = 'kit-view/component/text-area';
  static readonly SELECT_INPUT = 'kit-view/component/select-input';
  static readonly VALUE_LABEL = 'kit-view/component/value-label';
  static readonly VALUE_ERROR = 'kit-view/component/value-error';
  static readonly FORM_FIELD = 'kit-view/component/form-field';
  static readonly ALERT = 'kit-view/component/alert';
  static readonly BACKDROP = 'kit-view/component/backdrop';
  static readonly LOAD_INDICATOR = 'kit-view/component/load-indicator';
  static readonly CHECKBOX = 'kit-view/component/checkbox';
  static readonly TABS = 'kit-view/component/tabs';
  static readonly TAB = 'kit-view/component/tab';
}
